import { render, staticRenderFns } from "./mousePositionControl.vue.js?vue&type=template&id=42471b38&scoped=true!=!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./mousePositionControl.vue?vue&type=template&id=42471b38&scoped=true"
import script from "./mousePositionControl.vue.js?vue&type=script&lang=js!=!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./mousePositionControl.vue?vue&type=script&lang=js"
export * from "./mousePositionControl.vue.js?vue&type=script&lang=js!=!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./mousePositionControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42471b38",
  null
  
)

export default component.exports